module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/cards/flip-card/flip-card.component.scss
// module id = ./src/app/features/cards/flip-card/flip-card.component.scss
// module chunks = main